<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">
            <v-overlay v-model="overlay"
                :color= "storeBusiness.themecolor!='NULL'?storeBusiness.themecolor:'#FE5800'" >
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <!-- <v-card-title class="pa-0">
                <v-container style="min-height:100px;" class="">
                    <v-row>
                        <v-col
                        cols="12"
                        md="12"
                        color="white--text"
                        class="text-center "

                        >
                        Welcome to Juzzap
                        <br />
                        <span class style="font-size:16px;">A NEW PARADIGM</span>
                        </v-col>
                    </v-row>
                </v-container>

                <v-row class="pwa-content">
                <v-col cols="12" md="12" class="text-center">
                    <img :src="juzzapLogo" width="100" />
                </v-col>
                </v-row>


            </v-card-title> -->



            <v-card-text class="d-flex d-md-none">
                <v-row align="start" justify="center">
                    <v-col cols="12" sm="8" md="10">
                        <!-- <v-card class="elevation-4 mb-3"> -->
                            <v-card-title>
                                {{$t('zz_food_list')}}
                                <div class="flex-grow-1"></div>
                                    <!-- <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                                    single-line
                                    hide-details
                                    ></v-text-field> -->
                                    <v-btn color="primary" class="ml-3" @click="createfooditem">{{$t('zz_create_food_item')}}</v-btn>
                            </v-card-title>



                            <v-row >
                                <v-col cols="12" md="12">
                                    <v-card v-for="(item, index) in items" :key="index" tile class="cardlist pa-3 mb-3">
                                        <v-row>
                                            <v-col cols="4" class="pt-0 pb-0">
                                                <v-avatar
                                                    size="100%"
                                                    tile
                                                    class="cardlist"
                                                >
                                                    <img :src="item.fimage" />
                                                </v-avatar>
                                            </v-col>
                                            <v-col cols="8" md="8">
                                                <v-row class="ml-0 mr-0">
                                                    <v-col cols="9" class="pa-0">
                                                        <div><h3 class="foodtitle">{{item.title}}</h3></div>
                                                        <div>{{item.subtitle}}</div>


                                                    </v-col>
                                                    <v-col cols="3" md="3">
                                                        <v-btn @click="editFoodItem(item.id)" color="primary " fab x-small dark
                                                        class="mt-2 mb-2">
                                                            <v-icon>mdi-square-edit-outline</v-icon>
                                                        </v-btn>
                                                        <v-btn @click="deleteItem(item.id)" color="primary " fab x-small dark class="">
                                                            <v-icon>mdi-trash-can-outline</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        <!-- </v-card> -->
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="d-none d-md-flex " justify="right">

            <v-row >

                <v-col cols="6" class="text-left">

                    <v-btn color="#FE5800" class="ml-3 " @click="createfooditem">{{$t('zz_create_food_item')}}</v-btn>
                    <v-btn color="#FE5800" class="ml-3" v-if="isdragged" @click="savemenu" >{{$t('zz_save_food_menu_changes')}}</v-btn>
                    <span class="ml-3 success--text font-weight-bold" v-if="savemsg!=''">{{savemsg}}</span>

                    <v-btn v-if="selected.length>0" text tile  x-large raised  @click="deleteselecteditem()" color="primary" class="">
                      <span >Delete</span>
                    </v-btn>

                </v-col>
                <v-col cols="6" class="text-left">
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        :label="$t('zz_search')"
                        single-line
                        hide-details
                        ></v-text-field>
                </v-col>





            </v-row>

            </v-card-text>


            <v-card-text>
                <v-divider></v-divider>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="items"
                    :items-per-page="1000"
                    :search="search"
                    class="elevation-1"
                    hide-default-footer
                    :item-class="itemRowBackground"
                    :single-select="singleSelect"
                    show-select
                    >

                    <template v-slot:top>
                      <v-switch
                        v-model="singleSelect"
                        label="Single select"
                        class="pa-3"
                      ></v-switch>
                    </template>

                    <template v-slot:item.photo="{ item }">
                        <v-avatar
                        tile
                        class="">
                            <img :src="item.fimage" :alt="item.title" />

                        </v-avatar>

                    </template>

                    <template v-slot:item.title="{item}">

                        <v-edit-dialog
                        :return-value.sync="item.title"
                        large
                        persistent
                        @save="save(item.id,item.title)"
                        @cancel="cancel"
                        @open=""
                        @close=""
                        >
                            {{ item.title }}

                            <template v-slot:input>
                                <div class="mt-4 title">
                                    Update Title
                                </div>
                                <v-text-field
                                v-model="item.title"

                                label="Edit"
                                single-line

                                ></v-text-field>
                            </template>

                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.special="{item}">
                        <table>
                            <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id+'-'+cindex">

                            <td v-if="itema.special!=0" style="border:none;">{{itema.special}}</td>
                            </tr>
                        </table>


                    </template>



                    <template v-slot:item.favorites="{item}">
                        {{item.ordered}}
                    </template>

                    <template v-slot:item.price="{item}">
                        <table>
                            <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id+'-'+cindex">

                            <td style="border:none;">{{itema.price}}</td>
                            </tr>
                        </table>
                    </template>

                    <template v-slot:item.section="{item}">
                        <table>
                            <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id+'-'+cindex">

                            <td style="border:none;">{{itema.cname}}</td>
                            </tr>
                        </table>
                    </template>

                    <template v-slot:item.live="{item}">

                        <table>
                            <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id+'-'+cindex">
                                <td style="border:none;">
                                    <div v-if="itema.showitem==1 ">
                                        <v-switch  color="success" :input-value="shw"  @click="updateshowitem(item.id,itema.courseid,0)" :id="'showonitem-'+item.id"></v-switch>
                                    </div>
                                    <div v-else>
                                        <v-switch  color="" :input-value="nshw"  @click="updateshowitem(item.id,itema.courseid,1)" :id="'showonitem-'+item.id"></v-switch>

                                    </div>

                                </td>

                            </tr>
                        </table>
                    </template>



                    <template v-slot:item.action="{item}">

                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>fa fa-cogs</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-btn icon @click="editFoodItem(item.id)" color="primary " fab x-small dark
                                        class="mt-2 mb-2">
                                        <v-icon>mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                </v-list-item>

                                <v-list-item>
                                    <v-btn icon @click="deleteItemCourse(item.id)" color="primary " fab x-small dark class="">
                                        <v-icon>mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                    </template>


                </v-data-table>
            </v-card-text>

            <!--<v-card-text  class="d-none d-md-flex" style="width:100%;overflow-x:scroll;">




                <v-row>
                    <v-col cols="12">

                        <div >
                            <v-simple-table >
                                <thead>
                                    <tr>
                                        <th width="80" class="pr-0 pl-0" >Photo</th>
                                        <th width="380">Title</th>
                                        <th width="40" class="pl-0">Viewed</th>
                                        <th width="40" class="pl-0">Favorites</th>
                                        <th width="40" class="pl-0">%</th>
                                        <th width="40" class="pl-0">Special</th>
                                        <th width="40" class="pl-0">Price</th>
                                        <th width="70" class="pl-0">Section</th>
                                        <th width="30" class="pl-0" >Live</th>
                                        <th  class="pl-0">opt</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,cindex) in items" :key="'c-'+item.id">

                                        <td class="pr-0 pl-0" >
                                            <v-avatar
                                            tile
                                            class="">
                                                <img :src="item.fimage" />
                                            </v-avatar>
                                        </td>
                                        <td><strong>{{item.title}}</strong><br>{{item.subtitle}}</td>
                                        <td >{{item.viewed}}</td>
                                        <td >{{item.ordered}}</td>
                                        <td ></td>
                                        <td >


                                            <!-- {{item.special}}
                                            <table>
                                                <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id">

                                                <td v-if="itema.special!=0" style="border:none;">{{itema.special}}</td>
                                                </tr>
                                            </table>

                                        </td>
                                        <td >
                                            <!-- {{item.price}}

                                            <table>
                                                <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id">

                                                <td style="border:none;">{{itema.price}}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td >
                                            <table>
                                                <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id">

                                                <td style="border:none;">{{itema.cname}}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td>
                                            <table>
                                                <tr v-for="(itema,cindex) in item.coursesall" :key="'c-'+item.id">
                                                    <td style="border:none;">
                                                        <div v-if="itema.showitem==1 ">
                                                            <v-switch  color="success" :input-value="shw"  @click="updateshowitem(item.id,itema.courseid,0)" :id="'showonitem-'+item.id"></v-switch>
                                                        </div>
                                                        <div v-else>
                                                            <v-switch  color="" :input-value="nshw"  @click="updateshowitem(item.id,itema.courseid,1)" :id="'showonitem-'+item.id"></v-switch>

                                                        </div>

                                                    </td>

                                                </tr>
                                            </table>


                                        </td>
                                        <td  >
                                            <v-menu bottom left>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        color="primary"
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon>mdi-dots-horizontal</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item>
                                                        <span @click="editFoodItem(item.id)" color="primary " fab x-small dark
                                                            class="mt-2 mb-2">
                                                            Edit
                                                        </span>
                                                    </v-list-item>

                                                    <v-list-item>
                                                        <span @click="deleteItemCourse(item.id)" color="primary " fab x-small dark class="">
                                                            Delete
                                                        </span>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>


                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>


                        </div>

                        <!-- <v-data-table
                            :headers="headers"
                            :items="desserts"
                        ></v-data-table>
                    </v-col>
                </v-row>











            </v-card-text>-->
        </v-card>

        <v-dialog v-model="createitem" content-class="createitemdialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">

            <v-card v-if="createitem==true" tile class="" elevation="3" color="#fff">
                <CreateFoodItem  v-on:set-dialog="backtolist" :cid="cid"/>
            </v-card>



        </v-dialog>

        <v-dialog v-model="edititemdialog" content-class="createitemdialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">

            <v-card v-if="edititemdialog==true" tile class="" elevation="3" color="#fff">
                <EditFoodItem  v-on:set-dialog="backtolist" :editfooditemid="editfooditemid"/>
            </v-card>

        </v-dialog>

    </v-container>
</template>
<script>
import Vue from 'vue'
import draggable from 'vuedraggable'
import EditFoodItem from '@/components/FoodItemEdit.vue';
import CreateFoodItem from '@/components/FoodItemCreate.vue';


export default {
    props: {
    source: String
  },
  data: function () {return {
        singleSelect: false,
        selected: [],
        createitem:false,

        edititemdialog:false,
        editfooditemid:0,
        search:"",
        headers: [
            { text: this.$i18n.t('zz_photo'), value: "fimage" },
            { text: this.$i18n.t('zz_title'), value: "title" },
            { text: this.$i18n.t('zz_viewed'), value: "viewed" },
            { text: this.$i18n.t('zz_favorites'), value: "Favorites" },
            { text: this.$i18n.t('zz_special'), value: "Special" },
            { text: this.$i18n.t('zz_price'), value: "Price" },
            { text: this.$i18n.t('zz_section'), value: "Section" },
            { text: this.$i18n.t('zz_live'), value: "live" },
            { text: this.$i18n.t('zz_actions'), value: "action", sortable: false }




        ],
        idtypes: [],

          query: {
          search_input: ''
            },
          shw:true,
          nshw:false,
          switchValue:false,
          showonitem:true,
          headers: [
          {
            text: this.$i18n.t('zz_photo'),
            align: 'start',
            sortable: false,
            value: 'photo',
          },
          { text: this.$i18n.t('zz_title'), value: 'title' },
          { text: this.$i18n.t('zz_viewed'), value: 'viewed' },
          { text: this.$i18n.t('zz_favorites'), value: 'favorites' },
          { text: '%', value: 'per' },
          { text: this.$i18n.t('zz_special'), value: 'special' },
          { text: this.$i18n.t('zz_price'), value: 'price' },
          { text: this.$i18n.t('zz_section'), value: 'section' },
          { text: this.$i18n.t('zz_live'), value: "live" },
          { text: this.$i18n.t('zz_actions'), value: "action", sortable: false }
        ],

      foodview:'grid',

      savemsg:'',
      isdragged:0,
      dragitem:0,
      drag:0,
      overlay: false,

      juzzapLogo: require("@/assets/logo-Copy.png"),

    id:'',
    items: [],
    coursesall:[],
    itemimg:"",
    fooditems:{
        courses:[]
    },
  }},
    components: {
            draggable,
            EditFoodItem,
            CreateFoodItem,

        },
    created()
    {
        this.storeBusiness=JSON.parse(localStorage.getItem('business'));

        //    if (this.$route.params.id) {
        //   this.id = this.$route.params.id
        //    }

        this.id=this.storeBusiness.id;

        this.fetchrecord();

        if(this.storeBusiness.languagecode=='en'||this.storeBusiness.languagecode=='es'){
             // this.$i18n.locale=this.storeBusiness.languagecode;
            }

        // this.getBusiness();

    },
    computed:
    {

    },


    methods:
    {
        itemRowBackground: function (item)
        {
            // console.log('item '+item);
            // alert('method');
            // const rowClass = 'style-1';
            // return rowClass;

            //alert(item);
            //return  'style-1';
            if(item.separation > 0)
            {
            return  'style-1';
            }
            else
            {
            return  'style-2';

            }

        },
        deleteselecteditem()
        {
            if (confirm("Are you sure you want to delete this food item?"))
            {
                this.$http
                .post(this.$apidomain+"fooddeleteall",{ ids: this.selected })
                .then(res =>
                {

                // alert(res.data.retailids);
                if(res.data.success==1)
                {
                    this.$router.go("/");
                }
                })
                .catch(err => {
                console.log(err.response);
                });
            }
        },

        toggleAll ()
        {

            if (this.selected.length) this.selected = []
            else this.selected = this.items.slice()
        },
        createfooditem()
        {
          // this.$router.push({name:'createfooditem',params:{id:this.storeBusiness.id}});

          this.createitem=true;
        },

        backtolist()
        {

          this.edititemdialog=false;
          this.createitem=false;

        },
        editFoodItem(fooditemid)
        {

          this.editfooditemid=fooditemid;

          this.edititemdialog=true;

        },
        save (itemid,title)
        {
            //alert('item id'+itemid+' title '+title);

            this.$http
            .post(this.$apidomain+"updateitemtitle/"+itemid,{title:title})
            .then(res => {
                if(res.data.success==1)
                {

                        this.$http
                        .get(this.$apidomain+"itemlist/"+this.id)
                        .then(res =>
                        {
                                if(res.data.success==0)
                                {
                                    //this.$router.push({name:'businesslistnew'});
                                }
                                this.items = res.data.items;
                                this.$http
                                .get(this.$apidomain+"getfooditems/"+this.id)
                                .then(res =>
                                {
                                    if(res.data.success==0)
                                    {
                                        //this.$router.push({name:'businesslistnew'});
                                    }
                                    this.fooditems = res.data.fooditems;
                                    this.overlay=false;


                                })
                                .catch(err => {
                                    console.log(err.response);
                                    this.overlay=false;

                                });
                        // this.overlay=false;


                        })
                        .catch(err => {
                            console.log(err.response);
                            this.overlay=false;

                        });

                }



            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

        },

        cancel ()
        {

        },
        fetchrecord()
        {
            this.overlay=true;

            /*  this.$http
                .get(this.$apidomain+"itemlistnew/"+this.id)
                .then(res => {
                if(res.data.success==0)
                {
                    //this.$router.push({name:'businesslistnew'});
                }
                })
                .catch(err => {
                    console.log(err.response);


                });*/

            this.$http
            .get(this.$apidomain+"itemlist/"+this.id)
            .then(res =>
            {
                    if(res.data.success==0)
                    {
                        //this.$router.push({name:'businesslistnew'});
                    }
                    this.items = res.data.items;
                    this.$http
                    .get(this.$apidomain+"getfooditems/"+this.id)
                    .then(res =>
                    {
                        if(res.data.success==0)
                        {
                            //this.$router.push({name:'businesslistnew'});
                        }
                        this.fooditems = res.data.fooditems;
                        this.overlay=false;


                    })
                    .catch(err => {
                        console.log(err.response);
                        this.overlay=false;

                    });
            // this.overlay=false;


            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });
        },
      updateshowitem(itemid,courseid,showitem)
      {
         this.overlay=true;

        //  let showitem=showitem;
         //showitem= document.getElementById('showonitem-'+itemid).value;

        // console.log('show item value ' + showitem+' itemid '+itemid);

            this.$http
            .post(this.$apidomain+"updateitemcourseshow/"+itemid+"/"+courseid,{showitem:showitem})
            .then(res => {
                if(res.data.success==1)
                {

                        this.$http
                        .get(this.$apidomain+"itemlist/"+this.id)
                        .then(res => {
                            if(res.data.success==0)
                            {
                                //this.$router.push({name:'businesslistnew'});
                            }
                            this.items = res.data.items;
                                this.$http
                                .get(this.$apidomain+"getfooditems/"+this.id)
                                .then(res => {
                                    if(res.data.success==0)
                                    {
                                        //this.$router.push({name:'businesslistnew'});
                                    }
                                this.fooditems = res.data.fooditems;
                                    this.overlay=false;


                                })
                                .catch(err => {
                                    console.log(err.response);
                                    this.overlay=false;

                                });
                        // this.overlay=false;


                        })
                        .catch(err => {
                            console.log(err.response);
                            this.overlay=false;

                        });

                }



            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

      },
      savemenu()
      {
         this.overlay=true;

          this.$http
            .post(this.$apidomain+"savebusinessfoodmenu",{data:JSON.stringify(this.fooditems),businessid:this.id})
            .then(res => {
                if(res.data.success==1)
                {
                        this.isdragged=0;
                        this.savemsg=res.data.msg;
                        this.items = res.data.items;
                        this.$http
                        .get(this.$apidomain+"getfooditems/"+this.id)
                        .then(res => {
                            if(res.data.success==0)
                            {
                                //this.$router.push({name:'businesslistnew'});
                            }
                        this.fooditems = res.data.fooditems;
                            this.overlay=false;


                        })
                        .catch(err => {
                            console.log(err.response);
                            this.overlay=false;

                        });
                }
                // this.fooditems = res.data.fooditems
                // this.overlay=false;


            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });
      }  ,
      dragfooditem(dtype)
      {
            this.isdragged=1;
            this.savemsg='';
          if(dtype=='c')
          {
            this.drag=0;
          }

          if(dtype=='i')
          {
            this.dragitem=0;
          }

      } ,
    //   createfooditem()
    //   {
    //     this.$router.push({name:'createfooditem',params:{id:this.storeBusiness.id}});
    //   },
      editFoodItem_old(fooditemid)
      {
          this.$router.push({name:'editfooditem',params:{id:fooditemid,business_id:this.storeBusiness.id}});

      },

      deleteItem(fooditemid)
      {
            if (confirm("Are you sure you want to delete this Items?"))
            {
                this.overlay=true;

                this.$http
                .post(this.$apidomain+"deleteitem/"+fooditemid)
                .then(res =>
                {
                    this.$http
                    .get(this.$apidomain+"itemlist/"+this.id)
                    .then(res => {
                        if(res.data.success==0)
                        {
                            //this.$router.push({name:'businesslistnew'});
                        }
                        this.items = res.data.items;
                        this.$http
                        .get(this.$apidomain+"getfooditems/"+this.id)
                        .then(res => {
                            if(res.data.success==0)
                            {
                                //this.$router.push({name:'businesslistnew'});
                            }
                        this.fooditems = res.data.fooditems;
                            this.overlay=false;


                        })
                    .catch(err => {
                        console.log(err.response);
                        this.overlay=false;

                    });
                    this.overlay=false;


                     })
                    .catch(err => {
                        console.log(err.response);
                        this.overlay=false;

                    });
                    })
                .catch(err => {
                    console.log(err.response);
                });
            }
      },
      deleteItemCourse(itemcourseid)
      {
            if (confirm("Are you sure you want to delete this Items?"))
            {
                this.overlay=true;

                this.$http
                .post(this.$apidomain+"deleteitemcourse/"+itemcourseid)
                .then(res =>
                {
                    this.$http
                    .get(this.$apidomain+"itemlist/"+this.id)
                    .then(res => {
                        if(res.data.success==0)
                        {
                            //this.$router.push({name:'businesslistnew'});
                        }
                        this.items = res.data.items;
                        this.$http
                        .get(this.$apidomain+"getfooditems/"+this.id)
                        .then(res => {
                            if(res.data.success==0)
                            {
                                //this.$router.push({name:'businesslistnew'});
                            }
                        this.fooditems = res.data.fooditems;
                            this.overlay=false;


                        })
                    .catch(err => {
                        console.log(err.response);
                        this.overlay=false;

                    });
                    this.overlay=false;


                     })
                    .catch(err => {
                        console.log(err.response);
                        this.overlay=false;

                    });
                    })
                .catch(err => {
                    console.log(err.response);
                });
            }
      },
    }
}
</script>
<style scoped>
.foodtitle
{
    font-size:16px;
    line-height: 19px;
    font-weight:bold;
    text-transform:uppercase;
}
.cardlist{

    border-top-right-radius: 40px !important;
    border-bottom-left-radius: 40px !important;
}
.move
{
    cursor: nesw-resize;
}
.overflowcol{

    flex-shrink: 0;

}
.course_col{
    width:360px;
    float:left;
    padding: 15px;
}
.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}

.compact-form {
    transform: scale(0.875);
    transform-origin: left;
}


</style>
